import React from "react";
import { CategoryProductStore } from "../../Interfaces/Product"; // Adjust import path
import "./Categories.css";
import config from "../../config";

const Categories = ({
  categories,
  onSelectCategory,
  selectedCategoryName,
}: {
  categories: CategoryProductStore[];
  onSelectCategory: (category: CategoryProductStore) => void;
  selectedCategoryName: string | null;
}) => {
  return (
    <div className="participant-shop-category-display-categories">
      {categories.map((category) => (
        <div
          key={category.category}
          className={`participant-shop-category-display-category-card ${
            category.category === selectedCategoryName ? "selected" : ""
          }`}
          onClick={() => onSelectCategory(category)}
        >
          <div className="participant-shop-category-display-circle">
            <img
              src={
                `${config.BACKEND_BASE_IMAGE_LOCATION}${category.products[0].image_url}` ||
                ""
              }
              alt={category.display_name}
              className="participant-shop-category-display-category-image"
            />
          </div>
          <div className="participant-shop-category-display-category-name">
            {category.display_name}
          </div>
        </div>
      ))}
    </div>
  );
};

export default Categories;
